import React from 'react';

const Ogolne = () => {
  return (
    <React.Fragment>
      <h5 className="page-header firstColor">
        <b>Grupowe Ubezpieczenie TUW PZUW Opieka Medyczna</b> to profesjonalna{' '}
        <b>opieka medyczna</b>, <br />w renomowanych placówkach medycznych w
        całej Polsce dla współpracowników TVP, byłych pracowników TVP oraz
        członków ich rodzin.
      </h5>

      <p className="secondColor">
        Dla osób przystępujących do ubezpieczenia w ramach pakietu <b>senior</b>{' '}
        dostępny jest zakres <b>Komfort Senior</b>, który odpowiada zakresem
        zakresowi <b>Komfort</b> dla pracownika lub współpracownika.
      </p>

      <p className="secondColor">
        Jeżeli ubezpieczasz rodziców lub teściów w ramach pakietu senior,{' '}
        <b>możesz wybrać dla siebie inny wariant zakresu</b> — na przykład dla
        rodzica <b>Komfort Senior</b>, a dla siebie <b>Komfort Plus</b> lub{' '}
        <b>Optimum</b>.
      </p>

      <br />
      <div className="text-white p-2 sixthColor iconFromLeft moneyIcon">
        <h5 className="firstColor">
          <b>Składka za ubezpieczenie (opłata za miesiąc)</b>
        </h5>
      </div>
      <br />

      <table className="table table-striped table-condensed secondColor">
        <tbody>
          <tr>
            <th className="text-center">Pakiet / zakres</th>
            <th className="text-center">Komfort Senior Pracownik*</th>
            <th className="text-center">Komfort Senior Współpracownik**</th>
          </tr>
          <tr>
            <td className="text-center">Składka miesięczna</td>
            <td className="text-center">266,40 zł</td>
            <td className="text-center">385,50 zł</td>
          </tr>
        </tbody>
      </table>

      <p className="firstColor mt-3">
        * Dla rodziców/teściów pracownika TVP, którzy nie ukończyli 80 r.ż.
      </p>
      <p className="firstColor">
        ** Dla rodziców/teściów współpracownika lub byłego pracownika TVP oraz
        dla współpracowników i byłych pracowników TVP, którzy ukończyli 67 rok
        życia, a nie ukończyli 80 r.ż.
      </p>

      <br />
      <p className="secondColor">
        Składka za ubezpieczenie płatna jest na numer subkonta bankowego
        wskazanego na deklaracji przystąpienia do ubezpieczenia.
      </p>
    </React.Fragment>
  );
};

export default Ogolne;
